import React, { Component } from 'react';
import { connect } from 'react-redux';

import { openModal } from 'actions/modalActions';
import { fetchStripeCards, removeStripeCard, setDefaultCard } from 'actions/stripeCardActions';
import StripeDefaultCardSelector from 'selectors/StripeDefaultCardSelector';

import CreditCard from 'components/CreditCard/CreditCard';
import Loading from 'components/Loading/Loading';

import './style.css';

class PaymentMethods extends Component {
  constructor(props) {
    super(props);
    this.props.fetchStripeCards(props.user.profile.stripeCustomerId);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.user.profile.stripeCustomerId !== this.props.user.profile.stripeCustomerId) {
      this.props.fetchStripeCards(nextProps.user.profile.stripeCustomerId);
    }
  }

  handleAddCard = () => {
    this.props.openModal('add-payment-method-modal');
  }

  handleDeleteCard = (cardId) => {
    const { stripeCustomer, removeStripeCard: removeStripeCardFn } = this.props;

    if (stripeCustomer.id) {
      removeStripeCardFn(stripeCustomer.id, cardId);
    }
  }

  handleSetDefault = (cardId) => {
    const { stripeCustomerId } = this.props.user.profile;
    if (stripeCustomerId) {
      this.props.setDefaultCard(stripeCustomerId, cardId);
    }
  }

  renderLoading() {
    return (
      <div className="PaymentMethods">
        <Loading />
      </div>
    );
  }

  renderCardList() {
    const { stripeCards, defaultCard } = this.props;

    return stripeCards.data ? stripeCards.data.map((card, index) => {
      return (
        <CreditCard
          key={index}
          card={card}
          defaultCard={defaultCard}
          onDelete={this.handleDeleteCard}
          onSetDefault={this.handleSetDefault}
        />
      );
    }) :
      null;
  }

  render() {
    if (this.props.stripeCards.status === 'loading') {
      return this.renderLoading();
    }

    return (
      <div className="PaymentMethods">
        <div id="payment-methods" className="card">
          <div className="card-header bg-secondary">
            <h5 className="text-muted mb-0"> Payment Methods </h5>
          </div>

          <div className="card-block d-flex flex-column flex-sm-row flex-wrap align-content-around align-items-center">
            {this.renderCardList()}
            {this.props.stripeCards.edit_status === 'loading' && <Loading overlay />}

            <div
              id="trigger-add-payment-method-modal"
              className="justify-content-center add-payment-method payment-method card text-center"
              onClick={this.handleAddCard}
            >
              <i className="fa fa-plus fa-2x mb-2" />
              <p className="mb-0"> Add Payment Method </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    stripeCards: state.stripeCards,
    defaultCard: StripeDefaultCardSelector(state)
  };
}

export default connect(
  mapStateToProps,
  {
    openModal,
    fetchStripeCards,
    removeStripeCard,
    setDefaultCard
  }
)(PaymentMethods);



// WEBPACK FOOTER //
// ./src/pages/student/Profile/routes/Cards/index.js